<template>

    <section>

        <div class="md_common-bl _padding-add">
            <div class="inner">

                <!-- ここから form_admin-container -->
                <form action="" class="form_admin-container">

                    <!--::::::::::::::: Type : テキストフィールドタイプ :::::::::::::::-->
                    <div class="input-group">

                        <h3 class="heading_component-s">
                            <p class="main"><span>テキストフィールドタイプ</span></p>
                        </h3>

                        <!-- テキストフィールド -->
                        <div class="item form_text">
                            <div class="input-row">
                                <input type="text" maxlength="250" id="example-text">
                            </div>
                            <label for="example-text"><span>テキストフィールド</span></label>
                        </div>

                        <!-- パスワード -->
                        <div class="item form_text _password">
                            <div class="input-row">
                                <input type="password" id="normal-password">
                                <button type="button" id="passview-normal" class="passview js-toggle-on"><span></span></button>
                            </div>
                            <label for="normal-password"><span>パスワード</span></label>
                        </div>

                        <!-- メールアドレス -->
                        <div class="item form_text">
                            <div class="input-row">
                                <input type="email" id="example-email" inputmode="email">
                            </div>
                            <label for="example-email"><span>メールアドレス</span></label>
                        </div>

                    </div><!-- /Type : テキストフィールドタイプ -->

                    <!--::::::::::::::: Type : チェックボックス - withテキスト (垂直方向) :::::::::::::::-->
                    <div class="input-group">

                        <h3 class="heading_component-s">
                            <p class="main"><span>チェックボックス - withテキスト (垂直方向)</span></p>
                            <p class="sub"><span><code>.input-group</code>に何もヘルパークラスが無いと垂直方向に並びます。</span></p>
                        </h3>

                        <!-- CheckBoxItem -->
                        <div class="item form_checkbox-text">
                            <input type="checkbox" name="example-checkbox1" id="example-checkbox1-1">
                            <label for="example-checkbox1-1">
                                <div class="mark"></div>
                                <span>チェックボックス - withテキスト1</span>
                            </label>
                        </div>

                        <!-- CheckBoxItem -->
                        <div class="item form_checkbox-text">
                            <input type="checkbox" name="example-checkbox1" id="example-checkbox1-2">
                            <label for="example-checkbox1-2">
                                <div class="mark"></div>
                                <span>チェックボックス - withテキスト2</span>
                            </label>
                        </div>

                        <!-- CheckBoxItem -->
                        <div class="item form_checkbox-text">
                            <input type="checkbox" name="example-checkbox1" id="example-checkbox1-3">
                            <label for="example-checkbox1-3">
                                <div class="mark"></div>
                                <span>チェックボックス - withテキスト3</span>
                            </label>
                        </div>

                    </div><!-- /Type : チェックボックス - withテキスト (垂直方向) :::::::::::::::-->

                    <!--::::::::::::::: Type : チェックボックス - withテキスト (水平方向) :::::::::::::::-->
                    <div class="input-group _horizontal">

                        <h3 class="heading_component-s">
                            <p class="main"><span>チェックボックス - withテキスト (水平方向)</span></p>
                            <p class="sub"><span><code>.input-group</code>に<code>._horizontal</code>をヘルパークラスとして付けると、水平方向に並びます。</span></p>
                        </h3>

                        <!-- CheckBoxItem -->
                        <div class="item form_checkbox-text">
                            <input type="checkbox" name="example-checkbox2" id="example-checkbox2-1">
                            <label for="example-checkbox2-1">
                                <div class="mark"></div>
                                <span>チェックボックス - withテキスト1</span>
                            </label>
                        </div>

                        <!-- CheckBoxItem -->
                        <div class="item form_checkbox-text">
                            <input type="checkbox" name="example-checkbox2" id="example-checkbox2-2">
                            <label for="example-checkbox2-2">
                                <div class="mark"></div>
                                <span>チェックボックス - withテキスト2</span>
                            </label>
                        </div>

                        <!-- CheckBoxItem -->
                        <div class="item form_checkbox-text">
                            <input type="checkbox" name="example-checkbox2" id="example-checkbox2-3">
                            <label for="example-checkbox2-3">
                                <div class="mark"></div>
                                <span>チェックボックス - withテキスト3</span>
                            </label>
                        </div>

                    </div><!-- /Type : チェックボックス - withテキスト (水平方向) -->

                    <!--::::::::::::::: Type : ラジオボタン - withテキスト (垂直方向) :::::::::::::::-->
                    <div class="input-group">

                        <h3 class="heading_component-s">
                            <p class="main"><span>ラジオボタン - withテキスト (垂直方向)</span></p>
                            <p class="sub"><span><code>.input-group</code>に何もヘルパークラスが無いと垂直方向に並びます。</span></p>
                        </h3>

                        <!-- RadioItem -->
                        <div class="item form_radio-text">
                            <input type="radio" name="example-radio1" id="example-radio1-1" checked>
                            <label for="example-radio1-1">
                                <div class="mark"></div>
                                <span>ラジオボタン - withテキスト1</span>
                            </label>
                        </div>

                        <!-- RadioItem -->
                        <div class="item form_radio-text">
                            <input type="radio" name="example-radio1" id="example-radio1-2">
                            <label for="example-radio1-2">
                                <div class="mark"></div>
                                <span>ラジオボタン - withテキスト2</span>
                            </label>
                        </div>

                        <!-- RadioItem -->
                        <div class="item form_radio-text">
                            <input type="radio" name="example-radio1" id="example-radio1-3">
                            <label for="example-radio1-3">
                                <div class="mark"></div>
                                <span>ラジオボタン - withテキスト3</span>
                            </label>
                        </div>

                    </div><!-- /Type : ラジオボタン - withテキスト (垂直方向) -->

                    <!--::::::::::::::: Type : ラジオボタン - withテキスト (水平方向) :::::::::::::::-->
                    <div class="input-group _horizontal">

                        <h3 class="heading_component-s">
                            <p class="main"><span>ラジオボタン - withテキスト (水平方向)</span></p>
                            <p class="sub"><span><code>.input-group</code>に<code>._horizontal</code>をヘルパークラスとして付けると、水平方向に並びます。</span></p>
                        </h3>

                        <!-- RadioItem -->
                        <div class="item form_radio-text">
                            <input type="radio" name="example-radio2" id="example-radio2-1" checked>
                            <label for="example-radio2-1">
                                <div class="mark"></div>
                                <span>ラジオボタン - withテキスト1</span>
                            </label>
                        </div>

                        <!-- RadioItem -->
                        <div class="item form_radio-text">
                            <input type="radio" name="example-radio2" id="example-radio2-2">
                            <label for="example-radio2-2">
                                <div class="mark"></div>
                                <span>ラジオボタン - withテキスト2</span>
                            </label>
                        </div>

                        <!-- RadioItem -->
                        <div class="item form_radio-text">
                            <input type="radio" name="example-radio2" id="example-radio2-3">
                            <label for="example-radio2-3">
                                <div class="mark"></div>
                                <span>ラジオボタン - withテキスト3</span>
                            </label>
                        </div>

                    </div><!-- /Type : ラジオボタン - withテキスト (水平方向) -->

                    <!--::::::::::::::: Type : セレクトボックス (垂直方向) :::::::::::::::-->
                    <div class="input-group">

                        <h3 class="heading_component-s">
                            <p class="main"><span>セレクトボックス (垂直方向)</span></p>
                            <p class="sub"><span><code>.input-group</code>に何もヘルパークラスが無いと垂直方向に並びます。</span></p>
                        </h3>

                        <!-- SelectItem -->
                        <div class="item form_select">
                            <div class="text-row">テキスト</div>
                            <div class="input-row">
                                <select name="" id="">
                                    <option value="">example1</option>
                                    <option value="">example2</option>
                                    <option value="">example3</option>
                                    <option value="">example4</option>
                                </select>
                            </div>
                        </div>

                    </div><!-- /Type : セレクトボックス (垂直方向) -->

                    <!--::::::::::::::: Type : セレクトボックス (水平方向) :::::::::::::::-->
                    <div class="input-group _horizontal">

                        <h3 class="heading_component-s">
                            <p class="main"><span>セレクトボックス (水平方向)</span></p>
                            <p class="sub"><span><code>.input-group</code>に<code>._horizontal</code>をヘルパークラスとして付けると、水平方向に並びます。</span></p>
                        </h3>

                        <!-- SelectItem -->
                        <div class="item form_select">
                            <div class="text-row">テキスト</div>
                            <div class="input-row">
                                <select name="" id="">
                                    <option value="">example1</option>
                                    <option value="">example2</option>
                                    <option value="">example3</option>
                                    <option value="">example4</option>
                                </select>
                            </div>
                        </div>

                        <!-- SelectItem -->
                        <div class="item form_select">
                            <div class="text-row">テキスト</div>
                            <div class="input-row">
                                <select name="" id="">
                                    <option value="">example1</option>
                                    <option value="">example2</option>
                                    <option value="">example3</option>
                                    <option value="">example4</option>
                                </select>
                            </div>
                        </div>

                        <!-- SelectItem -->
                        <div class="item form_select">
                            <div class="text-row">テキスト</div>
                            <div class="input-row">
                                <select name="" id="">
                                    <option value="">example1</option>
                                    <option value="">example2</option>
                                    <option value="">example3</option>
                                    <option value="">example4</option>
                                </select>
                            </div>
                        </div>

                    </div><!-- /Type : セレクトボックス (水平方向) -->

                    <!--::::::::::::::: Type : 検索窓 :::::::::::::::-->
                    <div class="input-group">

                        <h3 class="heading_component-s">
                            <p class="main"><span>検索窓</span></p>
                        </h3>

                        <div class="form_search">
                            <input type="search" v-model="free_text">
                            <label for="submit-btn" class="md_svg-icon">
                                <SvgIconSearch />
                            </label>
                            <input type="submit" id="submit-btn" v-on:click="search()">
                        </div><!--/.search-->

                    </div><!-- /Type : 検索窓 -->

                    <!--::::::::::::::: Type : ToggleBtn :::::::::::::::-->
                    <div class="input-group">

                        <h3 class="heading_component-s">
                            <p class="main"><span>トグルボタン</span></p>
                        </h3>

                        <!-- ToggleBtn -->
                        <div class="item form_toggle js-toggle-on">
                            <!-- TextRow -->
                            <div class="text-row">
                                <label class="text" for="example-toggle">トグルボタン</label>
                            </div>
                            <!-- InputRow -->
                            <div class="input-row">
                                <input type="checkbox" id="example-toggle">
                                <label class="btn" for="example-toggle">
                                    <div class="circle"></div>
                                    <div class="text _off">OFF</div>
                                    <div class="text _on">ON</div>
                                </label>
                            </div>
                        </div><!-- /ToggleBtn -->

                    </div><!-- /Type : ToggleBtn -->

                </form>
                <!-- ここまで form_admin-container -->

            </div><!--/.inner-->
        </div><!--/.md-common-bl-->

    </section>

</template>


<script>
    //Svg
    import SvgIconSearch from '@/components/EndUser/svg/SvgIconSearch'

    export default {
        components: {
            //Svg
            SvgIconSearch
        },
        mounted() {

            ////////////////////////////////////////////////
            //  パスワードの一時的な可視化
            ////////////////////////////////////////////////
            window.addEventListener('DOMContentLoaded', function(){
                // (1)パスワード入力欄とボタンのHTMLを取得
                let passviewNormal = document.getElementById("passview-normal");
                let normalPassword = document.getElementById("normal-password");
                // (2)ボタンのイベントリスナーを設定
                passviewNormal.addEventListener("click", (e)=>{
                    // (3)ボタンの通常の動作をキャンセル（フォーム送信をキャンセル）
                    e.preventDefault();
                // (4)パスワード入力欄のtype属性を確認
                if( normalPassword.type === 'password' ) {
                    // (5)パスワードを表示する
                    normalPassword.type = 'text';
                } else {
                    // (6)パスワードを非表示にする
                    normalPassword.type = 'password';
                }
                });
            });

        }
    }
</script>
